import {sendEvent} from '@github-ui/hydro-analytics'
import {useEffect, useRef} from 'react'

import type {CopilotPlan} from '../utils/copilot-chat-types'

interface UseQuotaBannerShownTelemetryOptions {
  target?: string
  enabled?: boolean
  dedupeKey?: string
  mode: 'assistive' | 'immersive'
  plan: CopilotPlan | null | undefined
  tokenBasedBillingEnabled: boolean | undefined
  variant?: string | null
  quotaUsage?: number | null
}

export function useQuotaBannerShownTelemetry({
  target = 'QUOTA_BANNER_EXCEEDED',
  enabled = true,
  dedupeKey,
  mode,
  plan,
  tokenBasedBillingEnabled,
  variant,
  quotaUsage,
}: UseQuotaBannerShownTelemetryOptions) {
  const sentKeysRef = useRef<Set<string>>(new Set())

  useEffect(() => {
    const sentKeys = sentKeysRef.current
    return () => {
      sentKeys.clear()
    }
  }, [])

  useEffect(() => {
    if (!enabled) return

    const eventKey = dedupeKey ?? '__default__'
    if (sentKeysRef.current.has(eventKey)) return

    sentKeysRef.current.add(eventKey)

    sendEvent('dotcom_chat.activate', {
      target,
      action: 'shown',
      mode,
      tokenBasedBillingEnabled,
      plan,
      variant,
      quotaUsage,
    })
  }, [dedupeKey, enabled, mode, plan, target, tokenBasedBillingEnabled, variant, quotaUsage])
}
